import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';

import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import AppContent from './services/AppContent';
import PaymentCallbackPage from './pages/PaymentCallbackPage';
import RepairTrackPage from './pages/RepairTrackPage';
import Unauthorized from './services/Unauthorized';
import { AuthProvider } from './services/AuthContext';
import { SyncServiceProvider } from './services/DataSyncService';
import { SettingsProvider } from './services/SettingsContext';
import { ThemeModeProvider } from './contexts/ThemeContext';
import { lockService } from './services/LockService';
import { logHybridDiagnosticsOnce } from './services/hybridFlags';

const TrackThemeLayout = () => (
  <ThemeModeProvider defaultMode="dark" storageKey="trackThemeMode">
    <Outlet />
  </ThemeModeProvider>
);

const LabThemeLayout = () => (
  <ThemeModeProvider defaultMode="light" storageKey="themeMode">
    <Outlet />
  </ThemeModeProvider>
);

const App = () => {
  useEffect(() => {
    logHybridDiagnosticsOnce();
    return () => {
      lockService.cleanup();
    };
  }, []);

  return (
    <Router>
      <AuthProvider>
        <SyncServiceProvider>
          <SettingsProvider>
            <div dir="rtl">
              <Routes>
                <Route element={<TrackThemeLayout />}>
                  <Route path="/track" element={<RepairTrackPage />} />
                  <Route path="/track/:callNumber" element={<RepairTrackPage />} />
                </Route>

                <Route element={<LabThemeLayout />}>
                  <Route path="/login" element={<Login />} />
                  <Route path="/unauthorized" element={<Unauthorized />} />
                  <Route path="/payment-callback" element={<PaymentCallbackPage />} />
                  {/* כל הנתיבים המוגנים מופנים ל-AppContent */}
                  <Route path="/*" element={<PrivateRoute element={<AppContent />} role="viewer" />} />
                </Route>
              </Routes>
            </div>
          </SettingsProvider>
        </SyncServiceProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
